import { Injectable, EventEmitter } from '@angular/core';

import {
    SignalRService,
    SignalREventService,
    ToastrService,
    Company,
    Equipment,
    User,
    CompanyEquipment,
    CompanyUsers,
    DataArray,
    GlobalService
} from './../index';

@Injectable()
export class CompanyService {
    public companysChange: EventEmitter<{ companies: Company[], isFinalPage: boolean }> = new EventEmitter<{ companies: Company[], isFinalPage: boolean }>();
    public allCompaniesChange: EventEmitter<Company[]> = new EventEmitter<Company[]>();
    public allUsersChange: EventEmitter<User[]> = new EventEmitter<User[]>();
    public showDetailsChange: EventEmitter<Company> = new EventEmitter<Company>();
    public showEditChange: EventEmitter<Company> = new EventEmitter<Company>();
    public companyEquipmentChange: EventEmitter<CompanyEquipment> = new EventEmitter<CompanyEquipment>();
    public companyUsersChange: EventEmitter<CompanyUsers> = new EventEmitter<CompanyUsers>();
    public companyChange: EventEmitter<Company> = new EventEmitter<Company>();

    public companies: DataArray<Company> = new DataArray<Company>();
    public users: DataArray<User> = new DataArray<User>();

    private name = '';
    private actives = true;
    private inactives = true;
    private minesiteIds: number[] = [];
    private modelIds: number[] = [];
    private Live = false;
    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService,
        private _toastrService: ToastrService,
        private _GlobalService: GlobalService
    ) {
        this.registerOnServerEvents();
    }
    public getCompanies(): void {
        this._signalRService.invoke('GetCompanies', true);
    }
    public getCompaniesConstraint(live: boolean) {
        this.Live = live;
        this._signalRService.invoke('GetCompanies', live);
    }
    public getAllCompanies(): void {
        this._signalRService.invoke('GetAllCompanies');
    }
    public getAllUsers(): void {
        this._signalRService.invoke('GetAllUsers');
    }
    public showDetails(company: Company, Live: boolean): void {
        this.Live = Live;
        if (Live) {
            this.showDetailsChange.emit(company);
            this._signalRService.invoke('GetEquipmentForCompany', company.Id);
        } else {
            this.showDetailsChange.emit(company);
            this._signalRService.invoke('GetEquipmentForCompanyStaging', company.Id);
        }
        this._signalRService.invoke('GetUsersForCompany', company.Id, Live);
    }
    public create(company: Company, Live: boolean): void {
        this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            if (result != null) {
                if (result.IsNew) {
                    this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                    this.Live = Live;
                    this._signalRService.invoke('CreateCompany', company.Name, Live, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
                    this.Live = Live;
                    this._signalRService.invoke('CreateCompany', company.Name, Live, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
                    this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                }
            }
        });

    }
    public delete(companyId: number): void {
        this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            if (result != null) {
                if (result.IsNew) {
                    this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                    this._signalRService.invoke('DeleteCompany', companyId, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
                    this._signalRService.invoke('DeleteCompany', companyId, Number(localStorage.getItem('User_ID')));
                } else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
                    this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                }
            }
        });
    }
    public update(company: Company): void {
        this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
            if (result != null) {
                if (result.IsNew) {
                    this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                    this._signalRService.invoke('UpdateCompany', company.Id, company.Name, company.Active, Number(localStorage.getItem('User_ID')));
                }else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
                    this._signalRService.invoke('UpdateCompany', company.Id, company.Name, company.Active, Number(localStorage.getItem('User_ID')));
                }else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
                    this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
                    this._GlobalService.TriggerLockEnvironment('1');
                }
            }
        });
    }
    public updateCompanyUsers(companyId: number, companyUsers: number[]): void {
        this._signalRService.invoke('UpdateCompanyUsers', companyId, companyUsers, Number(localStorage.getItem('User_ID')));
    }
    public edit(company: Company): void {
        this.showEditChange.emit(company);
    }
    public getCompany(companyId: number, live: boolean): void {
        this._signalRService.invoke('GetCompany', companyId, live);
    }
    public applyFilter(name: string, actives: boolean, inactives: boolean, minesiteIds: number[], modelIds: number[], live: boolean): void {
        this.name = name;
        this.actives = actives;
        this.inactives = inactives;
        this.minesiteIds = minesiteIds;
        this.modelIds = modelIds;
        this._signalRService.invoke('FilterCompanies', this.name, this.actives, this.inactives, this.minesiteIds, this.modelIds, live);
    }
    public getCompaniesFiltered(): void {
        this._signalRService.invoke('FilterCompanies', this.name, this.actives, this.inactives, this.minesiteIds, this.modelIds);
    }
    private onCompanies(info: any): void {
        this.companies.init();
        for (const item of info.Data.Companies) {
            const company: Company = $.extend(new Company(), item);
            this.companies.update(company, true);
        }
        this.companysChange.emit({ companies: this.companies.Data, isFinalPage: info.Data.isFinalPage === true });
    }
    private onAllCompanies(info: any): void {
        this.companies.init();
        for (const item of info.Data.Companies) {
            const company: Company = $.extend(new Company(), item);
            this.companies.update(company, true);
        }
        this.allCompaniesChange.emit(this.companies.Data);
    }
    private onAllUsers(info: any): void {
        for (const item of info.Data.Users) {
            const user: User = $.extend(new User(), item);
            this.users.update(user, true);
        }
        this.allUsersChange.emit(this.users.Data);
    }
    private onCompanyEquipment(info: any): void {
        const companyEquipment: CompanyEquipment = new CompanyEquipment();
        companyEquipment.CompanyId = info.Data.CompanyId;
        for (const equipment of info.Data.Equipment) {
            companyEquipment.Equipment.push($.extend(new Equipment(), equipment));
        }
        this.companyEquipmentChange.emit(companyEquipment);
    }
    private onCompanyUsers(info: any): void {
        const companyUsers: CompanyUsers = new CompanyUsers();
        companyUsers.CompanyId = info.Data.CompanyId;
        for (const user of info.Data.Users) {
            companyUsers.Users.push($.extend(new User(), user));
        }
        this.companyUsersChange.emit(companyUsers);
    }
    private onCreateCompany(info: any): void {
        const company: Company = $.extend(new Company(), info.Data.Company);
        this._toastrService.displayToastrMessage('success', 'Company ' + info.Data.Company.Name + ' has been Created!', 'Create Company!');
        this.companies.unshift(company);
        this.companyChange.emit(company);
    }
    private onDeleteCompany(info: any): void {
        const company: Company = $.extend(new Company(), info);
        this.companies.update(company);
        this.companyChange.emit(company);
        this._toastrService.displayToastrMessage('success', 'Company ' + info.Name + ' has been deleted!', 'Delete Company!');
        this._signalRService.invoke('GetCompanies', false);
    }
    private onUpdateCompany(info: any): void {
        const company: Company = $.extend(new Company(), info.Data.Company);
        this.companies.update(company);
        this.companyChange.emit(company);
        this._toastrService.displayToastrMessage('success', 'Company ' + info.Data.Company.Name + ' has been updated!', 'Update Company!');
        this._signalRService.invoke('GetCompanies', false);
    }
    private registerOnServerEvents() {
        this._signalREventService.register('CompanyService', 'companies', (info: any) => this.onCompanies(info));
        this._signalREventService.register('CompanyService', 'allCompanies', (info: any) => this.onAllCompanies(info));
        this._signalREventService.register('CompanyService', 'allUsers', (info: any) => this.onAllUsers(info));
        this._signalREventService.register('CompanyService', 'beginRecieveCompanies', () => { this.companies.init(); });
        this._signalREventService.register('CompanyService', 'createcompany', (info: any) => this.onCreateCompany(info));
        this._signalREventService.register('CompanyService', 'deletecompany', (info: any) => this.onDeleteCompany(info));
        this._signalREventService.register('CompanyService', 'updatecompany', (info: any) => this.onUpdateCompany(info));
        this._signalREventService.register('CompanyService', 'companyequipment', (info: any) => this.onCompanyEquipment(info));
        this._signalREventService.register('CompanyService', 'companyusers', (info: any) => this.onCompanyUsers(info));
    }
    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('CompanyService');
    }
}
